import {
  THRESHOLD_LINE_DEFAULT_COLOR,
  THRESHOLD_LINE_WIDTH,
} from '../constants.js';
import { useGaugeChartThresholdContext } from '../hooks/useGaugeChartThresholdContext.js';
import { useThresholdConfigLines } from '../hooks/useThresholdConfigLines.js';

/**
 * @internal
 */
export const GaugeThresholdIndicators = () => {
  const thresholds = useGaugeChartThresholdContext();
  const lines = useThresholdConfigLines();

  return lines.map(
    (line, i) =>
      line &&
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      thresholds[i].showIndicator! && (
        <line
          key={`threshold-line-${i}`}
          x1={line.start.x}
          y1={line.start.y}
          x2={line.end.x}
          y2={line.end.y}
          strokeWidth={THRESHOLD_LINE_WIDTH}
          stroke={THRESHOLD_LINE_DEFAULT_COLOR}
        />
      ),
  );
};
